<template>
  <el-container>
    <el-main>
      <publicHomeHeader></publicHomeHeader>
      <div class="register-main" :style="{ 'min-height': `${mainHeight}px` }">
        <div class="register-title">
          HiBeds Signup
        </div>
        <div class="register-info">
          <!-- 进度条 开始 -->
            <div class="step-info-height">
              <div class="step-info">
                <div>① Complete the details</div>
                <div style="margin: 0 6%;"><img src="/static/img/login/u46.png" style="width: 20px; height: 20px; vertical-align: middle;"></div>
                <div>② Submit for review</div>
              </div>
            </div>
          <!-- 进度条 结束 -->
          <div style="padding:0 6%; height: auto;">
            <form class="el-form demo-ruleForm register-form">
              <!-- Country City 开始 -->
              <div class="form-online">
                <div class="msg-lastname" style="float:left; width: 350px;">
                  <div for="name" class="register-name">Country</div>
                  <div class="el-form-item__content">
                    <div class="el-input input-bor">
                      <el-select style="width:320px;" v-model="country" placeholder="Please select" filterable ref="country">
                        <!-- @change="countryChange" -->
                        <el-option v-for="item in countryList" :label="item.val" :key="item.key" :value="item.key">{{item.val}}</el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
                <div class="msg-lastname" style="float:left; width: 350px;">
                  <div for="name" class="register-name">City</div>
                  <div class="el-form-item__content">
                    <div class="el-input input-bor" style="width:320px;">
                      <input type="text" placeholder="Enter city" maxlength="200" autocomplete="off" @input="checkName('city')" class="el-input__inner" :class="{'codeError':getSomeThing('city')}" ref="city" @blur="blurs('city')">
                      <!-- <el-select style="width:320px;" v-model="city" :disabled="cityDisabled" placeholder="Please select" filterable ref="city">
                        <el-option v-for="item in cityList" :label="item.val" :key="item.key" :value="item.key">{{item.val}}</el-option>
                      </el-select> -->
                    </div>
                  </div>
                </div>
              </div>
              <!-- Street Address 开始 -->
              <div class="form-online">
                <div class="msg-lastname" style="float:left; width: 350px;">
                  <div for="name" class="register-name">Street Address (e.g., 123 Main St, Building No.)</div>
                  <div class="el-form-item__content">
                    <div class="el-input input-bor">
                      <div class="el-input" style="width: 670px;">
                        <input type="text" placeholder="Enter the full street address." maxlength="200" autocomplete="off" @input="checkAddress('streetAddress')" class="el-input__inner" :class="{'codeError':getSomeThing('streetAddress')}" ref="streetAddress" @blur="blurs('streetAddress')">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Floor/Unit (if applicable) 开始 -->
              <div class="form-online">
                <div class="msg-lastname" style="float:left; width: 350px;">
                  <div for="name" class="register-name">Floor/Unit (if applicable)</div>
                  <div class="el-form-item__content">
                    <div class="el-input input-bor">
                      <div class="el-input" style="width: 320px;">
                        <input type="text" placeholder="Enter floor or unit number." maxlength="200" autocomplete="off" @input="checkAddress('floorUnit')" class="el-input__inner" :class="{'codeError':getSomeThing('floorUnit')}" ref="floorUnit" @blur="blurs('floorUnit')">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Postal Code 开始 -->
              <div class="form-online">
                <div class="msg-lastname" style="float:left; width: 350px;">
                  <div for="name" class="register-name">Postal Code</div>
                  <div class="el-form-item__content">
                    <div class="el-input input-bor">
                      <div class="el-input" style="width: 320px;">
                        <input type="text" placeholder="Enter the postal code." maxlength="15" autocomplete="off" @input="checkAddress('postalCode')" class="el-input__inner" :class="{'codeError':getSomeThing('postalCode')}" ref="postalCode" @blur="blurs('postalCode')">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Company Name 开始 -->
              <div class="form-online">
                <div class="msg-lastname" style="float:left; width: 350px;">
                  <div for="name" class="register-name">Company Name</div>
                  <div class="el-form-item__content">
                    <div class="el-input input-bor">
                      <div class="el-input" style="width: 320px;">
                        <input type="text" placeholder="Enter company name" maxlength="200" autocomplete="off" @input="checkName('companyName')" class="el-input__inner" :class="{'codeError':getSomeThing('companyName')}" ref="companyName" @blur="blurs('companyName')">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Business License 开始 -->
              <!-- <div class="form-online" :style="{ 'height': `${imgHeight}px` }">
                <div class="msg-lastname" style="float:left;">
                  <div for="name" class="register-name">Business License</div>
                  <div class="el-form-item__content">
                    <el-upload
                      action="#"
                      ref="uploadImg"
                      class="upload-demo"
                      accept=".jpg,.jpeg,.png,.pdf"
                      :on-change="handleChange"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :limit="5"
                      :on-exceed="handleExceed"
                      :auto-upload="false"
                      :file-list="fileList"
                      multiple
                    >
                      <el-button
                        size="small"
                        class="upload-button"
                        type="primary"
                        style="width: auto;"
                      >
                        <img
                          src="/static/img/login/u17.png"
                          style="width: 12px; height: 12px; vertical-align: middle; margin-right: 2px;"
                        /> Business License
                      </el-button>
                      <span slot="tip" class="el-upload__tip" style="margin-left: 35px;">
                        JPG, PNG. Size is no bigger than 2M. No more than 5 files
                      </span>
                    </el-upload>
                  </div>
                </div>
              </div> -->
              <!-- Business Type 开始 -->
              <div class="form-online">
                <div class="msg-lastname" style="float:left; width: 350px;">
                  <div for="name" class="register-name">Business Type</div>
                  <div class="el-form-item__content">
                    <div class="el-input input-bor">
                      <el-select style="width:320px;" v-model="businessType" placeholder="Please select" filterable ref="businessType">
                        <el-option v-for="item in businessTypeList" :label="item" :key="item" :value="item">{{item}}</el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Currency 开始 -->
              <div class="form-online">
                <div class="msg-lastname" style="float:left; width: 350px;">
                  <div for="name" class="register-name">Currency</div>
                  <div class="el-form-item__content">
                    <div class="el-input input-bor">
                      <el-select style="width:320px;" v-model="currency" placeholder="Please select" filterable ref="currency">
                        <el-option v-for="item in currencyList" :label="item" :key="item" :value="item">{{item}}</el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Contact Name 开始 -->
              <div class="form-online">
                <div class="msg-lastname" style="float:left; width: 350px;">
                  <div for="name" class="register-name">Contact Name</div>
                  <div class="el-form-item__content">
                    <div class="el-input input-bor">
                      <div class="el-input" style="width: 320px;">
                        <input type="text" placeholder="First name" maxlength="200" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('firstName')}" ref="firstName" @blur="blurs('firstName')">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="msg-lastname" style="float:left; width: 350px;">
                  <div for="name" class="register-name"></div>
                  <div class="el-form-item__content">
                    <div class="el-input input-bor">
                      <div class="el-input" style="width: 320px;">
                        <input type="text" placeholder="Last name" maxlength="200" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('lastName')}" ref="lastName" @blur="blurs('lastName')">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Phone Email 开始 -->
              <div class="form-online">
                <div class="msg-lastname" style="float:left; width: 350px;">
                  <div for="name" class="register-name">Phone</div>
                  <el-input placeholder="Enter phone number" v-model="tel" class="input-with-select" style="width: 320px; border-bottom-left-radius: 4px; border-top-left-radius: 4px;" @blur="checkInfo($event)" :class="{'codeError': telError === true}" ref="tel">
                    <el-select style="width:95px;" v-model="countryCode" slot="prepend" filterable>
                      <el-option v-for="item in telList" :label="item.val" :key="item.key" :value="item.key">{{item.val}}</el-option>
                    </el-select>
                  </el-input>
                </div>
                <div class="msg-lastname" style="float:left; width: 350px;">
                  <div for="name" class="register-name">Email</div>
                  <div class="el-form-item__content">
                    <div class="el-input input-bor">
                      <div class="el-input" style="width: 320px;">
                        <input type="text" placeholder="Enter email" maxlength="200" autocomplete="off" class="el-input__inner" :class="{'codeError':getSomeThing('email')}" ref="email" @blur="blurs('email')">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Additional Information 开始 -->
              <div class="form-online" style="height: 120px;">
                <div class="msg-lastname" style="float:left; width: 670px;">
                  <div for="name" class="register-name">Additional Information</div>
                  <el-input type="textarea" placeholder="" v-model="additionalInformation"  ref="informationRequirements"  @input="checkInformation" maxlength="1000" show-word-limit class="el-input__inner information-text"></el-input>
                </div>
              </div>
              <div class="form-online" style="height: 20px; position: relative;">
                <p class="terms-font">
                  <el-checkbox v-model="termsChecked">
                    I have read and agreed to Hibeds' <span style="color:rgb(22, 155, 213);" @click="frameTermAndUseDialog = true">Terms and Conditions</span>.
                  </el-checkbox>
                </p>
                <div v-show="termsError" style="color: red; font-size: 10px; position: absolute; top: 18px;">Please agree to HiBeds's Privacy Policy to continue.</div>
              </div>
              <div class="marginTop15" style="width: 100%;">
                <div style="width: 140px;">
                  <el-button @click="submitUpload()" data-index="register-button" tabindex="3" v-if="isDiasbleSignUp === false">Sign up</el-button>
                  <el-button class="disabled-button" data-index="register-button" tabindex="3" v-else>Sign up</el-button>
                  <el-dialog :visible.sync="registerResDia" :show-close="termsAndConditionsShowClose" class="res-margin" top="35vh">
                    <div slot="title" style="text-align: center;font-size: 16px;color: #303133;">
                      <div>Submission Successful</div>
                    </div>
                    <div class="en-text">
                      <div>Your application has been submitted successfully.</div>
                      <div>Our team will contact you via email within 5 working days.</div>
                    </div>
                    <div @click="registerResDia = false" style="border-top: 1px solid rgba(221, 223, 226, 1);font-weight: 100; font-style: normal; font-size: 16px; color: #5392F9; text-align: center; height: 60px;margin: 20px -5px -30px -5px;">
                      <el-button tabindex="3" style="margin: 10px 0;">OK</el-button>
                    </div>
                  </el-dialog>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </el-main>
    <publicFooter></publicFooter>
    <frameTermAndUse :frameTermAndUseDialog="frameTermAndUseDialog"></frameTermAndUse>
  </el-container>
  </template>
<script>
import {getRegisterInfo, getCityByCountry, register} from '@/request/city.js'
import publicFooter from '@/components/public/publicFooter'
import publicHomeHeader from '@/components/public/publicHomeHeader'
import frameTermAndUse from '@/components/public/frameTermAndUse'
// import axios from 'axios'
export default {
  name: 'register',
  components: {
    publicFooter,
    publicHomeHeader,
    frameTermAndUse
  },
  data () {
    return {
      remindFaild: false,
      inputEmail: '',
      register_send_show: false,
      pwdInput: '',
      remindMsg: 'Please enter your email address or password.',
      search_json: {},
      eyeOpenImg: '/static/img/login/eye-open.png',
      eyeCloseImg: '/static/img/login/eye-close.png',
      showPassImg: false,
      eyeOpen: true,
      country: '',
      // city: '',
      countryList: [],
      cityList: [],
      cityDisabled: true,
      someArray: [],
      fileList: [],
      fileListNew: [],
      businessTypeList: [],
      businessType: '',
      currencyList: [],
      currency: '',
      firstName: '',
      lastName: '',
      countryCode: '',
      tel: '',
      telList: [],
      additionalInformation: '',
      termsChecked: false, // Terms and Conditions.
      termsCheckedError: false,
      termsAndConditionsShowClose: true,
      frameTermAndUseDialog: false,
      telError: false,
      imgHeight: 60,
      termsError: false,
      registerResDia: false,
      mainHeight: document.documentElement.clientHeight - 72,
      isDiasbleSignUp: false
    }
  },
  mounted () {
    this.getRegisterInfo()
  },
  watch: {
    registerResDia: function (n, o) {
      if (n === false) {
        window.location.href = 'https://www.hibeds.com'
      }
    }
  },
  methods: {
    async submitUpload () {
      this.isDiasbleSignUp = true
      this.fileListNew = []
      if (['', 'null', null].includes(this.country)) {
        this.$refs['country'].focus()
        this.isDiasbleSignUp = false
        return false
      }
      if (['', 'null', null].includes(this.city)) {
        this.$refs['city'].focus()
        this.isDiasbleSignUp = false
        return false
      }
      this.$options.methods.blurs.bind(this)('city')
      let cityInfo = this.$options.methods.getSomeThing.bind(this)('city')
      if (cityInfo === true) {
        this.$refs['city'].focus()
        this.isDiasbleSignUp = false
        return false
      }
      this.$options.methods.blurs.bind(this)('streetAddress')
      let streetAddressInfo = this.$options.methods.getSomeThing.bind(this)('streetAddress')
      if (streetAddressInfo === true) {
        this.$refs['streetAddress'].focus()
        this.isDiasbleSignUp = false
        return false
      }
      this.$options.methods.blurs.bind(this)('floorUnit')
      let floorUnitInfo = this.$options.methods.getSomeThing.bind(this)('floorUnit')
      if (floorUnitInfo === true) {
        this.$refs['floorUnit'].focus()
        this.isDiasbleSignUp = false
        return false
      }
      this.$options.methods.blurs.bind(this)('postalCode')
      let postalCodeInfo = this.$options.methods.getSomeThing.bind(this)('postalCode')
      if (postalCodeInfo === true) {
        this.$refs['postalCode'].focus()
        this.isDiasbleSignUp = false
        return false
      }
      this.$options.methods.blurs.bind(this)('companyName')
      let companyNameInfo = this.$options.methods.getSomeThing.bind(this)('companyName')
      if (companyNameInfo === true) {
        this.$refs['companyName'].focus()
        this.isDiasbleSignUp = false
        return false
      }
      // if (this.fileList.length === 0) {
      //   this.$message.warning('Upload a Business License')
      //   this.isDiasbleSignUp = false
      //   return false
      // }
      if (['', 'null', null].includes(this.businessType)) {
        this.$refs['businessType'].focus()
        this.isDiasbleSignUp = false
        return false
      }
      if (['', 'null', null].includes(this.currency)) {
        this.$refs['currency'].focus()
        this.isDiasbleSignUp = false
        return false
      }
      this.$options.methods.blurs.bind(this)('firstName')
      let firstNameInfo = this.$options.methods.getSomeThing.bind(this)('firstName')
      if (firstNameInfo === true) {
        this.$refs['firstName'].focus()
        this.isDiasbleSignUp = false
        return false
      }
      this.$options.methods.blurs.bind(this)('lastName')
      let lastNameInfo = this.$options.methods.getSomeThing.bind(this)('lastName')
      if (lastNameInfo === true) {
        this.$refs['lastName'].focus()
        this.isDiasbleSignUp = false
        return false
      }
      if (['', 'null', null].includes(this.tel)) {
        this.$refs['tel'].focus()
        this.isDiasbleSignUp = false
        return false
      }
      if (['', 'null', null].includes(this.additionalInformation)) {
        this.$refs['informationRequirements'].focus()
        this.isDiasbleSignUp = false
        return false
      }
      if (this.termsChecked === false) {
        this.termsError = true
        this.isDiasbleSignUp = false
        return false
      } else {
        this.termsError = false
      }
      // for (let i = 0; i < this.fileList.length; i++) {
      //   const formData = new FormData()
      //   formData.append('file', this.fileList[i].raw)
      //   try {
      //     const response = await axios.post('/api/registerUpload', formData, {
      //       headers: {
      //         'Content-Type': 'multipart/form-data'
      //       }
      //     })
      //     var result = response.data
      //     this.fileListNew.push(result.data.path)
      //   } catch (error) {
      //     console.error('Failed to upload file:', error)
      //   }
      // }
      this.isDiasbleSignUp = true
      // 获取用户填写信息
      var streetAddress = this.$refs['streetAddress'].value
      var floorUnit = this.$refs['floorUnit'].value
      var postalCode = this.$refs['postalCode'].value
      var companyName = this.$refs['companyName'].value
      var city = this.$refs['city'].value
      var firstName = this.$refs['firstName'].value
      var lastName = this.$refs['lastName'].value
      var email = this.$refs['email'].value

      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var sessionid = this.common.sessionidGet(this)
      // 订单信息填写数据
      var dataJson = {
        'country': this.country,
        'city': city,
        'streetAddress': streetAddress,
        'floorUnit': floorUnit,
        'postalCode': postalCode,
        'companyName': companyName,
        'fileList': this.fileListNew,
        'businessType': this.businessType,
        'currency': this.currency,
        'firstName': firstName,
        'lastName': lastName,
        'countryCode': this.countryCode,
        'tel': this.tel,
        'email': email,
        'additionalInformation': this.additionalInformation,
        'time': time,
        'sessionid': sessionid
      }
      console.log('dataJson', dataJson)
      var registerJson = this.common.encryptionData(dataJson, this)
      register(registerJson).then(res => {
        if (['200'].includes(res.flag)) {
          this.registerResDia = true
        } else if (['201'].includes(res.flag)) {
          this.$message.warning('Upload a Business License')
          this.isDiasbleSignUp = false
          return false
        } else {
          this.$message.error('Network error, please try again')
          this.isDiasbleSignUp = false
        }
      })
    },
    checkInfo (data) {
      let pattern = ''
      if (this.tel === '' || this.tel === null) {
        this.telError = true
      } else {
        pattern = /^[0-9]*$/
        if (this.countryCode === '49') {
          pattern = /^1[0-9]{10}$/
        }
        if (!pattern.test(this.tel)) {
          this.telError = true
        } else {
          this.telError = false
        }
      }
    },
    getRegisterInfo () {
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {'time': time, 'sessionid': sessionid, 'operation': 'getRegisterInfo'}
      var data = this.common.encryptionData(dataJson, this)
      getRegisterInfo(data).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.loadPageView(data, res, requestTime, responseTime)
        if (res.flag === '200') {
          this.countryList = res.data.countryList
          this.businessTypeList = res.data.businessTypeList
          this.currencyList = res.data.currencyList
          this.telList = res.data.telList
          this.countryCode = 223
        }
      })
    },
    countryChange () {
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {'country': this.country, 'time': time, 'sessionid': sessionid, 'operation': 'getCityInfo'}
      var data = this.common.encryptionData(dataJson, this)
      getCityByCountry(data).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.loadPageView(data, res, requestTime, responseTime)
        if (res.flag === '200') {
          this.cityDisabled = false
          this.cityList = res.data
        } else {
          this.cityList = []
          this.cityDisabled = true
        }
        this.city = ''
      })
    },
    getSomeThing (index) { // 返回数组元素
      return this.someArray[index]
    },
    handleChange (file, fileList) {
      this.fileList = fileList
      this.imgHeight = this.imgHeight + 27
      // this.fileList.push({'uid': file.uid, 'name': file.name})
      console.log('handleChange')
      console.log('file', file)
      console.log('fileList', fileList)
    },
    handleRemove (file, fileList) {
      this.fileList = this.fileList.filter(item => item.uid !== file.uid)
      this.imgHeight = this.imgHeight - 27
      // this.fileList.splice(file.uid, 1)
      console.log('file', file)
      console.log('fileList', fileList)
      console.log('fileList1', this.fileList)
    },
    handlePreview (file) {
      console.log('handlePreview')
      // console.log(file)
    },
    handleProgress (file, fileList) {
      console.log('handleProgress')
      this.imgHeight = this.imgHeight + 27
    },
    handleExceed (files, fileList) {
      console.log('handleExceed')
      this.$message.warning(`The current limit is 5 files`)
    },
    handleBefore (file) {
      console.log('handleBefore')
      var isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('The size of the uploaded file cannot exceed 2MB')
      }
    },
    handleSuccess (file, fileList) {
      if (file.flag === '200') {
        this.fileList.push({'uid': fileList.uid, 'name': file.data.name, 'url': file.data.path})
      } else {
        console.log('shibai')
      }
      console.log('handleSuccess')
      // console.log('successfileList', fileList)
      // console.log('fileList', this.fileList)
    },
    checkInformation () {
      this.additionalInformation = this.additionalInformation.replace(/[\u4e00-\u9fa5/]|[^a-zA-Z0-9\u4E00-\u9FA5\s+,.!-?:;()/]/g, '')
    },
    blurs (refInfo) {
      var refName = this.$refs[refInfo].value
      var pattern = ''
      if (refName === '' || refName === null) {
        this.$set(this.someArray, refInfo, true)
      } else {
        if (refInfo === 'emails') {
          pattern = /^([a-zA-Z]|[0-9])(\.|\w|-)+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
          if (!pattern.test(refName)) {
            this.emailError = 'pleaseValidEmailReservationConfirmationEmail'
            this.$set(this.someArray, refInfo, true)
          } else {
            this.userEmail = refName
            this.$set(this.someArray, refInfo, false)
          }
        } else if (refInfo === 'firstName' || refInfo === 'lastName') {
          pattern = /^[a-zA-Z\s]+$/
          if (!pattern.test(refName)) {
            this.$set(this.someArray, refInfo, true)
          } else {
            this.$set(this.someArray, refInfo, false)
          }
        } else {
          this.$set(this.someArray, refInfo, false)
        }
      }
    },
    checkName (name) {
      this.$refs[name].value = this.$refs[name].value.replace(/[\u4e00-\u9fa5/]|[^a-zA-Z0-9\u4E00-\u9FA5\s+,.!-?:;()/]/g, '')
    },
    checkAddress (name) {
      this.$refs[name].value = this.$refs[name].value.replace(/[\u4e00-\u9fa5]/, '')
    }
    // getUploadUrl (uploadParams) {
    //   var data = {file: uploadParams.file, uid: uploadParams.file.uid}
    //   console.log('data', data)
    //   var res = axios.create({
    //     timeout: 70000, // 请求超时时间
    //     method: 'post',
    //     headers: {
    //       'Content-Type': 'application/json;charset=UTF-8'
    //     },
    //     url: 'http://localhost.admin/data/hibedsUpload',
    //     data
    //   })
    //   console.log('res', res.data.uid)
    // },
  }
}
</script>
<style scoped>
  .el-main{ background-color: rgba(83,102,161,0.37); min-width: 800px;}
  .register-main{width:100%;padding-bottom:10px; margin:0 auto;height: auto;}
  .register-title{
    font-size: 28px;
    font-weight: 650;
    text-align: center;
    margin: 40px 0;
  }
  .register-info{width: 765px; height: auto; min-height: 500px; margin: 0 auto; background-color: rgba(255, 255, 255, 0.6);border: none;border-radius: 20px; margin-bottom: 30px;}
  .step-info{ text-align: center;width: 50%; margin: 0 auto;}
  .step-info-height{height: 50px; border-bottom: 1px solid rgba(215, 215, 215, 1);}
  .step-info div{display: inline; line-height: 50px; font-size: 14px;}
  /deep/ .el-range-editor.is-active, /deep/ .el-range-editor.is-active:hover, /deep/ .el-select .el-input.is-focus .el-input__inner{border-color: rgba(83, 102, 163, 1);}
  /deep/ .register-info .el-select-dropdown__item.selected{color:rgba(83, 102, 163, 1) !important;}
  /* 表单 */
  .register-name{font-weight: 500; height: 20px;}
  .forgotpassword{color: rgba(83, 102, 163, 1);text-decoration: none;}
  .forgotpassword:hover{color: #296FF7;}
  .register-form{padding:15px 0px; color:#606266;font-size: 14px;}
  .form-online{margin-bottom:15px; width: 700px;height: 60px;}
  .upload-button, .upload-button:focus, .upload-button:hover{width: autopx;height: 40px; font-size:14px; background-color: rgba(83, 102, 163, 1) !important;border: 1px solid rgba(83, 102, 163, 1) !important;border-radius: 5px;color: #FFFFFF !important;}
  .information-text{height: 100px; font-size: 14px;padding: 0px;border:none;}
  .information-text /deep/ textarea{height:100%;resize:none}
  .terms-font /deep/ .el-checkbox__label{ font-size: 12px !important; font-weight: 400;}
  .tc-content span{ font-weight: 400;font-size: 14px;line-height: 22px; display:block; margin-bottom:20px;white-space: normal; height:auto;}
  .en-text{font-size: 12px; color: #303133; text-align: left; line-height: 24px;margin-top:-30px;overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;}
  /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{color: #303133 !important;}
  /deep/ .el-button, .register_send, /deep/ .el-button:focus, .register_send:focus{width: 140px;height: 40px; font-size:14px; background-color: rgba(83, 102, 163, 1);border: 1px solid rgba(83, 102, 163, 1);border-radius: 5px;color: #FFFFFF;}
  /deep/ .register_send:hover{background-color: #FFF; border: 1px solid rgba(83, 102, 163, 1); color:rgba(83, 102, 163, 1);}
  .marginTop40{margin-top: 40px;}
  .marginTop35{margin-top: 35px;}
  .marginTop25{margin-top: 25px;}
  .marginTop15{margin-top: 15px;}
  .marginTop10{margin-top: 10px;}
  .marginLeft0{margin-left: 0px !important;}
  .el-form-item__content{height: 40px;}
  /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner{background-color: rgba(83, 102, 163, 1);border-color:rgba(83, 102, 163, 1);}
  /deep/ .el-checkbox__inner:hover,/deep/ .el-checkbox-button__inner:hover{border-color:rgba(83, 102, 163, 1);}
  /deep/ .el-input__inner:focus, /deep/ .el-textarea__inner:focus{border-color:rgba(83, 102, 163, 1);box-shadow:0px 0px 8px rgba(83, 102, 163, 1);}
  .codeError /deep/ .el-input__inner:focus{border:1px solid #DCDFE6; box-shadow: none;}
  .codeError /deep/ .el-select .el-input.is-focus .el-input__inner{border: initial;}
  /deep/ .el-button:focus, .el-button:hover{width: 140px;height: 40px; font-size:14px;background-color: #FFF; border: 1px solid rgba(83, 102, 163, 1); color:rgba(83, 102, 163, 1);}
  /* /deep/ .el-select-dropdown__item.selected{color: rgba(83, 102, 163, 1) !important;} */
  .register /deep/ .el-input__inner{padding: 0 45px 0 15px;}
  .res-margin{ width: 800px; margin: 0 auto;}
  /*提示*/
  .register-remind-notice{border-width: 0px;min-height: 56px;background: inherit;border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
  .register-remind-notice-text{line-height: 20px; font-size: 14px;font-weight: 400;color:#5392F9;display:inline-block;width:90%;margin-top:10px}
  .register-remind-notice img {width: 18px;height: 18px;margin-right: 5px;}
  /* 登录提醒 */
  .register-remind{ border-width: 0px;height: 56px;background: inherit;background-color: rgba(240, 249, 235);border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
  .register-remindinfo{padding-right: 18px;display: flex;justify-content: center;align-items: center; line-height:56px;}
  .register-img{ margin: 18px;width: 18px;height: 18px;background-color: rgba(103, 194, 58, 1);border: none;border-radius: 15px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;text-align: center;line-height: normal;display:inline-block; margin-right:10px;}
  .register-remind-text{color: #67C23A;line-height: 20px; font-size:14px;display:inline-block;width:90%;}
  /* 失败 */
  .register-remind-faild{overflow: hidden;background: inherit;background-color: rgba(254, 240, 240, 1);border-width: 0px;height: 56px;border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
  .register-img-faild{margin: 18px;width: 18px;height: 18px;background-color: rgba(245, 108, 108, 1);border: none;border-radius: 15px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;text-align: center;line-height: normal;display:inline-block; margin-right:10px;}
  .register-remind-text-faild{color: #FF001F;font-size: 10px;display: block;margin-top: -8px;}
  .codeError,.codeError:focus,.codeError:hover{background: inherit;background-color: rgba(255, 255, 255, 1) !important;box-sizing: border-box;border: 1px solid rgba(225, 45, 45, 1) !important;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
  .mybox-leave-active,
  .mybox-enter-active {
    transition: all 1s ease;
  }
  .mybox-leave-active,
  .mybox-enter {
    height: 0px !important;
  }
  .mybox-leave,
  .mybox-enter-active {
    height: 56px;
  }
  .disabled-button, .disabled-button:hover, .disabled-button:focus{background-color: #D7D7D7; border-color: #D7D7D7; cursor: no-drop; color: #FFF;}
  /* @media only screen and (min-width:431px) and (max-width:600px) {
    .register-info{width: 420px;
      margin: 0 auto;
      margin-top: -100px;
      background-color: rgba(255, 255, 255, 0.6);
      border: none;
      border-radius: 20px;
    }
  }
  @media only screen and (min-width:391px) and (max-width:430px) {
    .register-info{width: 380px;
      margin: 0 auto;
      margin-top: -100px;
      background-color: rgba(255, 255, 255, 0.6);
      border: none;
      border-radius: 20px;
    }
  }
  @media only screen and (max-width:390px) {
    .register-info{width: 350px;
      margin: 0 auto;
      margin-top: -100px;
      background-color: rgba(255, 255, 255, 0.6);
      border: none;
      border-radius: 20px;
    }
  } */
</style>



// WEBPACK FOOTER //
// src/components/login/register.vue